import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=63564fd2&scoped=true"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"
import style0 from "./Donations.vue?vue&type=style&index=0&id=63564fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63564fd2",
  null
  
)

export default component.exports